export default "__VITE_ASSET__213e6e12__"